import { Button } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const DropdownButtonStyled = styled(Button)<{ $isOpened: boolean }>`
  font-weight: 700;
  height: 3.8rem;
  padding: 0 1rem;
  font-size: 1.6rem;
  line-height: 2.6rem;

  /* For open/closed alignment */
  border: 0 solid transparent;
`;
